<div class="page-content flex fill center-center">
  <div>
    <mat-card appearance="outlined" class="mat-elevation-z6">
      <mat-card-header>
        <mat-card-title>{{'function.Login' | translate}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-login-control [isModal]="false" (enterKeyPress)="loginControl.login()"></app-login-control>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="primary" [disabled]="loginControl.isLoading" (click)="loginControl.login()">@if (loginControl.isLoading) {
          <mat-spinner [diameter]="24"></mat-spinner>
        }{{'function.Login' | translate | uppercase}}</button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
